if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      // When the days unit is hidden, roll the days into the hours total.
      const displayHours = this.daysEl ? hours - days * 24 : hours;

      if (this.daysEl) {
        this.daysEl.textContent = days > 9 ? days : `0${days}`;
      }
      this.hoursEl.textContent = displayHours > 9 ? displayHours : `0${displayHours}`;
      this.minsEl.textContent = (mins - hours * 60) > 9 ? mins - hours * 60 : `0${mins - hours * 60}`;
      this.secsEl.textContent = (secs - mins * 60) > 9 ? secs - mins * 60 : `0${secs - mins * 60}`;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
